import { createAsyncThunk } from '@reduxjs/toolkit'
import { getGamesListService, getGamesSettingsService, restartGameService, updateGamesSettingsService, updateGameStatusService } from 'network/services/gameSettings.service'

export const getGamesList = createAsyncThunk(
  'get/GamesList',
  async (data, thunkApi) => {
    try {
      const res = await getGamesListService(data)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const getGamesSettings = createAsyncThunk(
  'get/GamesSettings',
  async (data, thunkApi) => {
    try {
      const res = await getGamesSettingsService(data)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const updateGameStatus = createAsyncThunk(
  'update/gameStatus',
  async ({ data, onSuccess, handleDialogClose }, thunkApi) => {
    try {
      const res = await updateGameStatusService(data)
      onSuccess()
      handleDialogClose()
      return res
    } catch (error) {
      handleDialogClose()
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const crashRestartGame = createAsyncThunk(
  'fetch/restartGame',
  async (gameId, thunkApi) => {
    try {
      const res = await restartGameService(gameId)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const updateGamesSettings = createAsyncThunk(
  'update/GamesSettings',
  async ({ gameId, updates, onSuccessRedirect }, thunkApi) => {
    try {
      const res = await updateGamesSettingsService({ gameId, updates })
      onSuccessRedirect()
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)
